document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-hero-track]');
    var realSlides = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || realSlides.length <= 1) return;

    var n = realSlides.length;

    var firstClone = realSlides[0].cloneNode(true);
    var lastClone = realSlides[n - 1].cloneNode(true);
    track.insertBefore(lastClone, realSlides[0]);
    track.appendChild(firstClone);

    var active = 1; // 1..n are the real slides; 0 and n+1 are the loop clones

    var TRANSITION_MS = 800;
    var settleTimer = null;

    function applyTransform(extraPx, animate) {
      track.style.transition = animate ? '' : 'none';
      var base = active * -100;
      track.style.transform = 'translateX(calc(' + base + '% + ' + (extraPx || 0) + 'px))';
    }

    function settleLoop() {
      if (active <= 0) {
        active = n;
        applyTransform(0, false);
      } else if (active >= n + 1) {
        active = 1;
        applyTransform(0, false);
      }
    }
    track.addEventListener('transitionend', settleLoop);

    function goTo(i, animate) {
      active = i;
      applyTransform(0, animate !== false);
      clearTimeout(settleTimer);
      if (animate !== false) settleTimer = setTimeout(settleLoop, TRANSITION_MS + 50);
    }

    function next() { goTo(active + 1); }
    function prev() { goTo(active - 1); }

    goTo(1, false);

    var dragging = false;
    var dragStartX = 0;
    var dragDelta = 0;
    var containerWidth = 0;

    function beginDrag(x) {
      settleLoop();
      dragging = true;
      dragStartX = x;
      dragDelta = 0;
      containerWidth = root.clientWidth || 1;
      clearTimeout(settleTimer);
      track.style.transition = 'none';
    }
    function moveDrag(x) {
      var raw = x - dragStartX;
      var max = containerWidth;
      dragDelta = Math.max(-max, Math.min(max, raw));
      applyTransform(dragDelta, false);
    }
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      var THRESHOLD = containerWidth * 0.15;
      if (Math.abs(dragDelta) > THRESHOLD) {
        if (dragDelta < 0) { next(); } else { prev(); }
      } else {
        goTo(active);
      }
    }

    var touchStartX = 0;
    var touchStartY = 0;
    var touchIntentDecided = false;
    var touchIsHorizontal = false;

    root.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
      touchIntentDecided = false;
      touchIsHorizontal = false;
      dragging = false;
    }, { passive: true });

    root.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      var dx = t.clientX - touchStartX;
      var dy = t.clientY - touchStartY;
      if (!touchIntentDecided) {
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
          touchIntentDecided = true;
          touchIsHorizontal = Math.abs(dx) > Math.abs(dy);
          if (touchIsHorizontal) beginDrag(touchStartX);
        }
      }
      if (touchIsHorizontal) moveDrag(t.clientX);
    }, { passive: true });

    root.addEventListener('touchend', function () {
      if (touchIsHorizontal) endDrag();
    }, { passive: true });

    if (window.matchMedia('(pointer: fine)').matches) {
      root.style.cursor = 'grab';

      root.addEventListener('mousedown', function (e) {
        if (e.target.closest('a, button')) return;
        beginDrag(e.clientX);
        root.style.cursor = 'grabbing';
        e.preventDefault();
      });

      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        moveDrag(e.clientX);
      });

      window.addEventListener('mouseup', function () {
        if (!dragging) return;
        root.style.cursor = 'grab';
        endDrag();
      });
    }
  });
});
